<template>
    <div>
        <router-view />
        <Dialog
            header="Processamento em andamento"
            :visible.sync="dialogProcessamentoEmAndamento"
            :modal="true"
            :closable="true"
            :style="{ width: '480px' }"
        >
            <Message severity="warn" :closable="false">
                <p>Não foi possível concluir esta operação porque já existe um cálculo ou ajuste em andamento para um ou mais funcionários do período informado.</p>
                <p>Aguarde a conclusão do processamento atual e tente novamente. Essa proteção evita inconsistências e duplicidades nos cálculos de ponto.</p>
        
            </Message>
            <template #footer>
                <Button label="OK" icon="pi pi-check" @click="dialogProcessamentoEmAndamento = false" />
            </template>
        </Dialog>
    </div>
</template>

<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

export default {
    components: { Dialog, Button },
    data() {
        return {
            dialogProcessamentoEmAndamento: false
        };
    },
    created() {
        this.$root.$on('alerta-processamento-em-andamento', () => {
            this.dialogProcessamentoEmAndamento = true;
        });
    },
    beforeDestroy() {
        this.$root.$off('alerta-processamento-em-andamento');
    }
};
</script>